import { defineStore } from 'pinia'

import { Nullable } from '@shared/models/types/primary'

import { ChatWidget } from '@protos/apps/pc/chat_widget_pb'

import { getLauncherIcon } from '@pc/helpers/launcher-icon'

interface State {
  isChatOpened: boolean
}

const state = (): State => ({
  isChatOpened: false,
})

export const useDemoModeStore = defineStore('demo', {
  state,

  actions: {
    updateDemoChatVisibility(isShown: boolean) {
      this.isChatOpened = isShown
      window.parent.postMessage(isShown ? 'open' : 'close', '*')
    },

    updateDemoChatButton(widget?: Nullable<ChatWidget>) {
      window.parent.postMessage(
        {
          id: 'button',
          color:
            document.documentElement.style.getPropertyValue(
              '--branding-color'
            ) || '#0069a6',
          launcherImageURL: getLauncherIcon(widget),
          windowScale: false,
          isChatOpen: this.isChatOpened,
          newMessagesCount: 0,
        },
        '*'
      )
    },
  },
})
